import { render, staticRenderFns } from "./IntakeListHeaderItem.vue?vue&type=template&id=f2e79220&scoped=true&"
import script from "./IntakeListHeaderItem.vue?vue&type=script&lang=js&"
export * from "./IntakeListHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./IntakeListHeaderItem.vue?vue&type=style&index=0&id=f2e79220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e79220",
  null
  
)

export default component.exports